var _path, _path2, _path3, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCareProgramVas = function SvgCareProgramVas(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.962 8.649c-.018-.798-.035-1.552-.035-2.276 0-1.1-1.052-1.992-2.345-1.992-5.002 0-8.799-1.212-11.948-3.813-.917-.757-2.353-.757-3.27 0C11.217 3.169 7.42 4.38 2.419 4.38c-1.293 0-2.345.893-2.345 1.992 0 .74-.017 1.5-.035 2.307-.085 3.762-.19 8.444 1.66 12.694 1.017 2.337 2.557 4.367 4.577 6.036 2.3 1.9 5.314 3.408 8.956 4.48a2.714 2.714 0 0 0 1.536 0c3.643-1.072 6.657-2.58 8.958-4.48 2.02-1.669 3.56-3.7 4.577-6.036 1.85-4.25 1.745-8.933 1.66-12.695v-.03Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.686 13.33c0 5.683-6.716 9.432-8.76 10.428a1.36 1.36 0 0 1-1.167 0C13.715 22.762 7 19.13 7 13.331 7 10.4 9.16 8 11.788 8c2.102 0 3.854 1.465 4.496 3.515C16.927 9.465 18.737 8 20.781 8c2.744 0 4.905 2.402 4.905 5.33Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "CareProgramVas_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 8,
    width: 19,
    height: 16
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.686 13.33c0 5.683-6.716 9.432-8.76 10.428a1.36 1.36 0 0 1-1.167 0C13.715 22.762 7 19.13 7 13.331 7 10.4 9.16 8 11.788 8c2.102 0 3.854 1.465 4.496 3.515C16.927 9.465 18.737 8 20.781 8c2.744 0 4.905 2.402 4.905 5.33Z",
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#CareProgramVas_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.686 15.33c0 5.683-6.716 9.432-8.76 10.428a1.36 1.36 0 0 1-1.167 0C14.715 24.762 8 21.13 8 15.331 8 12.4 10.16 10 12.788 10c2.102 0 3.854 1.464 4.496 3.515.643-2.05 2.453-3.515 4.497-3.515 2.744 0 4.905 2.402 4.905 5.33Z",
    fill: "#40B6C2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16.708 23.309-.005.002a.862.862 0 0 1-.72 0l-.005-.002c-1.006-.49-3.146-1.623-5.029-3.333C9.061 18.26 7.5 16.026 7.5 13.33c0-2.705 1.986-4.831 4.288-4.831 1.852 0 3.432 1.29 4.02 3.164a.5.5 0 0 0 .954 0c.585-1.87 2.221-3.164 4.019-3.164 2.426 0 4.405 2.134 4.405 4.83 0 2.637-1.56 4.87-3.451 6.603-1.884 1.727-4.026 2.888-5.027 3.376Z",
    stroke: "#222",
    strokeLinejoin: "round"
  }))));
};
export default SvgCareProgramVas;